"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BackToChannelLink = function BackToChannelLink(_ref) {
  var onClick = _ref.onClick,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Back to channel' : _ref$label;
  var _useCustomChatContext = (0, _utils.useCustomChatContext)(),
    appMenuCollapsed = _useCustomChatContext.appMenuCollapsed;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('channel-search__back-block', {
      'app-menu-collapsed': appMenuCollapsed
    })
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    onClick: onClick,
    className: "channel-search__back-button icon-arrow"
  }, label));
};
var _default = BackToChannelLink;
exports.default = _default;